export function StarIcon({
  color = 'inherit',
  className,
  size = 24,
  fill = 'inherit',
  strokeWidth = 1,
  ...otherProps
}: {
  size?: number | string
} & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 22"
      fill={fill}
      stroke={color}
      strokeWidth={strokeWidth}
      // strokeLinecap="round"
      // strokeLinejoin="round"
      aria-hidden={otherProps['aria-label'] ? undefined : 'true'}
      {...otherProps}
    >
      <path d="M12.0004 18.3666L6.46711 21.7C6.22266 21.8555 5.96711 21.9222 5.70044 21.9C5.43377 21.8778 5.20044 21.7889 5.00044 21.6333C4.80044 21.4778 4.64488 21.2831 4.53377 21.0493C4.42266 20.8155 4.40044 20.5546 4.46711 20.2666L5.93377 13.9666L1.03377 9.73331C0.81155 9.53331 0.672883 9.30531 0.617772 9.04931C0.562661 8.79331 0.579105 8.54353 0.667105 8.29998C0.755994 8.05553 0.889327 7.85553 1.06711 7.69998C1.24488 7.54442 1.48933 7.44442 1.80044 7.39998L8.26711 6.83331L10.7671 0.899976C10.8782 0.633309 11.0507 0.433309 11.2844 0.299976C11.5182 0.166642 11.7569 0.0999756 12.0004 0.0999756C12.2449 0.0999756 12.4836 0.166642 12.7164 0.299976C12.9493 0.433309 13.1218 0.633309 13.2338 0.899976L15.7338 6.83331L22.2004 7.39998C22.5116 7.44442 22.756 7.54442 22.9338 7.69998C23.1116 7.85553 23.2449 8.05553 23.3338 8.29998C23.4227 8.54442 23.4396 8.79464 23.3844 9.05064C23.3293 9.30664 23.1902 9.5342 22.9671 9.73331L18.0671 13.9666L19.5338 20.2666C19.6004 20.5555 19.5782 20.8169 19.4671 21.0506C19.356 21.2844 19.2004 21.4786 19.0004 21.6333C18.8004 21.7889 18.5671 21.8778 18.3004 21.9C18.0338 21.9222 17.7782 21.8555 17.5338 21.7L12.0004 18.3666Z" />
    </svg>
  )
}
